export class UserSession {
    Id: number;
    UserName: string;
    LoginSuccess: boolean;
    LoginFailedReason: string;
    LoginDateTime: Date;
    LogoutDateTime: Date;
    LastActivity: Date;
    IsCurrentActivity: boolean;
}